<div class="main_content px-3 position-relative">
  <div class="container-fluid py-3">
    <div class="title mb-4">
      <h2 class="w-100">Users Authorizations</h2>
    </div>

    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="white_box shadow p-3">
          <br />
          <div class="row">
            <div class="col-md-12 add_ded_tbl">
              <table class="table">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Sr.No.</th>
                    <th scope="col">Customer Email</th>
                    <th scope="col">Customer</th>
                    <th scope="col">Card ID</th>
                    <th scope="col">Amount Collected</th>
                    <th scope="col">Collect </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let i of transactions; let a = index">
                    <th scope="row">{{ transactions.length - a }}</th>
                    <td>{{ i.email }}</td>
                    <td><a href="https://dashboard.stripe.com/customers/{{ i.stripe_cidnew }}" target="_blank">Customer <i class="fa fa-paper-plane"></i></a></td>
                    <td>{{ i.auth_card }}</td>
                    <td>${{ i.collected }}</td>
                    <td> <button class="btn btn-success" (click)="collectAmount(i.id)"><i class="fa fa-plus"></i> Collect Amount</button> </td>
                  </tr>
                </tbody>
              </table>   
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #UploadFileModal let-modal>
  <div class="modal-content">
    <div class="card">
      <div class="card-header text-dark d-flex justify-content-between align-items-center">
        <h5 class="modal-title mb-0">Collect Cash</h5>
        <button type="button" class="btn-close btn-close-white" aria-label="Close"
                (click)="modalService.dismissAll()">
          x
        </button>
      </div>
      <div class="card-body">
        <p class="card-text">Please select a amount to collect.</p>
        <div class="mb-1">
          <input class="form-control" type="number" min="1" step="1" [(ngModel)]="cashbackValue" required />
          <input class="form-control" type="hidden" [(ngModel)]="user_of" required />
        </div>

      </div>
      <div class="card-body">
        <p class="card-text">Passcode.</p>
        <div class="mb-3">
          <input class="form-control" type="password"  [(ngModel)]="passCode" required /> 
        </div>

      </div>
      <div class="card-footer d-flex justify-content-end">
        <button type="button" class="btn btn-primary mr-2" (click)="handleUpload()"
                [disabled]="isUploading">
          <i class="fas fa-save"></i> Collect
        </button>
        <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()"
                [disabled]="isUploading">
          <i class="fas fa-times"></i> Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>
